(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function (e) {
  var menuToggle = e.target.closest('a.menu');
  if (!menuToggle) return;

  var icon = menuToggle.querySelector('.icon-menu');
  if (!icon) return;

  icon.classList.toggle('icon-menu--active');
});

  } catch(e) { console.error(e); }
})();
})();
